/**
 * Help 页面多语言内容
 * lang 三种值：zh-CN（默认）、zh-TW、en-US
 * 注意：最终正式内容可能完全不同，目前仅为机翻占位
 */

const content = {
  'zh-CN': {
    pageTitle: (appName) => `「${appName}」 安全中心`,
    sections: {
      advanceRule: '垫付规则',
      listenDispatch: {
        title: '听单派单',
        q1: '听不到单/听单较少的原因',
        q1Sub: '听单窍门：',
        q1a1: '1 .听单中请避免频繁将司机端切换至后台运行（如接打电话、浏览其它软件等），以免导致网络延迟影响听单。',
        q1a2: '2 .前往热点商圈听单：早晚高峰期间订单需求较多，可前往办公楼或热点商圈接单。',
        q2: '接单距离较远',
        q2a: '尊敬的车主，派单是系统根据乘客发单位置进行派单，也是优先派给距离乘客最近的司机师傅的；如订单派单较远，可能是当前所属位置的司机较少，也希望您正常服务乘客，感谢您及时的反馈，平台会根据您的反馈进行改善',
      },
      order: {
        title: '订单相关',
        q1: '乘客出行计划有变',
        q1a: '若乘客表示无法出行，建议您与乘客协商取消订单。如您仍有疑问，请联系客服为您处理.',
        q2: '接单后无法服务',
        q2a: '尊敬的车主，接单后因个人或其他原因无法服务乘客，请及时向乘客致歉说明，可协商取消订单请乘客另外叫车。',
        q3: '接单后联系不上乘客',
        q3a: '到达上车位置后联系不上乘客，如果当日取消1次以内，可以直接取消，并且等候超时，会有一定超时赔偿哦；如果当日取消超过了1次，请联系客服取消，同样，如果等候超时，也会有一定超时赔偿哦~',
        q4: '如何修改订单价格',
        q4a: '若订单金额异常需要修改，请点击【转人工】反馈客服处理，感谢您的理解。',
      },
      withdraw: {
        title: '提现相关',
        q1: '如何提现',
        q1a: '点击司机端左上角【我】•【钱包】•【提现】即可提现，提现只能提现到本人支付宝账户哦~下方【提现规则】可了解具体规则，提现不收取手续费。',
        q2: '提现到账时间',
        q2a: '提现成功后2小时到账，如逾期没有到账，请您查询支付宝-出入账明细和司机端账户是否有退回哦~',
      },
      reward: {
        title: '奖励相关',
        q1: '未收到奖励',
        q1Sub: '未收到奖励分为以下情况：',
        q1a1: '1 .完成订单不符合奖励规则：您也在奖励界面查询规则内要求的订单数、成交率、订单时间和地点等，只有完成符合奖励条件的订单才可以哦。',
        q1a2: '2 .奖励发放时间：奖励分实时到账和结束后统一发放两种哦，您可根据奖励规则内的发放时间判断您的奖励发放情况。',
        q1a3: '3 .奖励延迟发放：当奖励获得人数超限或其它原因导致奖励延迟发放的，平台会及时做出通知，还请符合奖励的师傅们，不要着急耐心等待一下下~',
        q2: '收到奖励金额不正确',
        q2a: '收到奖励金额不正确，请先核是否完成奖励要求，您可根据您的接单情况，自行计算您的奖励金额。如您的奖励符合要求暂时未发放，我们会在7天内给您补发，请您关注您的账户流水。',
      },
      driverService: {
        title: '司机服务',
        q1: '司机提供哪些服务',
        q1a: '尊敬的车主，好的服务更能获得乘客的认可和好评哦。如准时到达、保持车内整洁等，根据乘客需求选择是否开空调，将会给乘客带来舒适的行程。',
      },
      extraFee: {
        title: '附加费用',
        q1: '高速费/过桥费如何处理',
        q1a: '尊敬的车主，高速费和过桥费是在服务乘客时，经过高速和高架桥时产生的费用，当订单产生高速费和过桥费时需要您和乘客确认后，由乘客线下自行支付给司机的哦~',
        q1Tip: '温馨提示：如乘客往返行程，需要与乘客沟通后，才能收取双程费用哦~',
      },
      pricingRule: {
        workday: '工作日计价规则',
        restday: '休息日计价规则',
      },
    },
    table: {
      timePeriod: '时间段',
      startingPrice: '起步价',
      mileagePrice: '里程单价',
      durationPrice: '时长单价',
      longDistance20: '远途起始里程20单价',
      longDistance30: '远途起始里程30单价',
    },
  },

  'zh-TW': {
    pageTitle: (appName) => `「${appName}」 安全中心`,
    sections: {
      advanceRule: '墊付規則',
      listenDispatch: {
        title: '聽單派單',
        q1: '聽不到單/聽單較少的原因',
        q1Sub: '聽單竅門：',
        q1a1: '1 .聽單中請避免頻繁將司機端切換至後台運行（如接打電話、瀏覽其它軟體等），以免導致網路延遲影響聽單。',
        q1a2: '2 .前往熱點商圈聽單：早晚高峰期間訂單需求較多，可前往辦公樓或熱點商圈接單。',
        q2: '接單距離較遠',
        q2a: '尊敬的車主，派單是系統根據乘客發單位置進行派單，也是優先派給距離乘客最近的司機師傅的；如訂單派單較遠，可能是當前所屬位置的司機較少，也希望您正常服務乘客，感謝您及時的反饋，平台會根據您的反饋進行改善',
      },
      order: {
        title: '訂單相關',
        q1: '乘客出行計劃有變',
        q1a: '若乘客表示無法出行，建議您與乘客協商取消訂單。如您仍有疑問，請聯繫客服為您處理.',
        q2: '接單後無法服務',
        q2a: '尊敬的車主，接單後因個人或其他原因無法服務乘客，請及時向乘客致歉說明，可協商取消訂單請乘客另外叫車。',
        q3: '接單後聯繫不上乘客',
        q3a: '到達上車位置後聯繫不上乘客，如果當日取消1次以內，可以直接取消，並且等候超時，會有一定超時賠償哦；如果當日取消超過了1次，請聯繫客服取消，同樣，如果等候超時，也會有一定超時賠償哦~',
        q4: '如何修改訂單價格',
        q4a: '若訂單金額異常需要修改，請點擊【轉人工】反饋客服處理，感謝您的理解。',
      },
      withdraw: {
        title: '提現相關',
        q1: '如何提現',
        q1a: '點擊司機端左上角【我】•【錢包】•【提現】即可提現，提現只能提現到本人支付寶帳戶哦~下方【提現規則】可了解具體規則，提現不收取手續費。',
        q2: '提現到帳時間',
        q2a: '提現成功後2小時到帳，如逾期沒有到帳，請您查詢支付寶-出入帳明細和司機端帳戶是否有退回哦~',
      },
      reward: {
        title: '獎勵相關',
        q1: '未收到獎勵',
        q1Sub: '未收到獎勵分為以下情況：',
        q1a1: '1 .完成訂單不符合獎勵規則：您也在獎勵介面查詢規則內要求的訂單數、成交率、訂單時間和地點等，只有完成符合獎勵條件的訂單才可以哦。',
        q1a2: '2 .獎勵發放時間：獎勵分即時到帳和結束後統一發放兩種哦，您可根據獎勵規則內的發放時間判斷您的獎勵發放情況。',
        q1a3: '3 .獎勵延遲發放：當獎勵獲得人數超限或其它原因導致獎勵延遲發放的，平台會及時做出通知，還請符合獎勵的師傅們，不要著急耐心等待一下下~',
        q2: '收到獎勵金額不正確',
        q2a: '收到獎勵金額不正確，請先核實是否完成獎勵要求，您可根據您的接單情況，自行計算您的獎勵金額。如您的獎勵符合要求暫時未發放，我們會在7天內給您補發，請您關注您的帳戶流水。',
      },
      driverService: {
        title: '司機服務',
        q1: '司機提供哪些服務',
        q1a: '尊敬的車主，好的服務更能獲得乘客的認可和好評哦。如準時到達、保持車內整潔等，根據乘客需求選擇是否開空調，將會給乘客帶來舒適的行程。',
      },
      extraFee: {
        title: '附加費用',
        q1: '高速費/過橋費如何處理',
        q1a: '尊敬的車主，高速費和過橋費是在服務乘客時，經過高速和高架橋時產生的費用，當訂單產生高速費和過橋費時需要您和乘客確認後，由乘客線下自行支付給司機的哦~',
        q1Tip: '溫馨提示：如乘客往返行程，需要與乘客溝通後，才能收取雙程費用哦~',
      },
      pricingRule: {
        workday: '工作日計價規則',
        restday: '休息日計價規則',
      },
    },
    table: {
      timePeriod: '時間段',
      startingPrice: '起步價',
      mileagePrice: '里程單價',
      durationPrice: '時長單價',
      longDistance20: '遠途起始里程20單價',
      longDistance30: '遠途起始里程30單價',
    },
  },

  'en-US': {
    pageTitle: (appName) => `"${appName}" Safety Center`,
    sections: {
      advanceRule: 'Advance Payment Rules',
      listenDispatch: {
        title: 'Order Listening & Dispatch',
        q1: 'Reasons for Not Receiving / Receiving Fewer Orders',
        q1Sub: 'Tips for receiving orders:',
        q1a1: '1. While listening for orders, please avoid frequently switching the driver app to background (e.g., making calls, browsing other apps), as this may cause network delays and affect order reception.',
        q1a2: '2. Go to popular business districts to listen for orders: During morning and evening rush hours, there is higher demand. You can go to office buildings or popular areas to pick up orders.',
        q2: 'Long Pickup Distance',
        q2a: 'Dear driver, the dispatch system assigns orders based on the passenger\'s location and prioritizes the nearest driver. If orders are dispatched from far away, it may be because there are fewer drivers in your current area. We hope you will continue to serve passengers as usual. Thank you for your feedback — the platform will make improvements accordingly.',
      },
      order: {
        title: 'Order Related',
        q1: 'Passenger\'s Travel Plans Changed',
        q1a: 'If the passenger indicates they cannot travel, we suggest you negotiate with the passenger to cancel the order. If you still have questions, please contact customer service for assistance.',
        q2: 'Unable to Serve After Accepting Order',
        q2a: 'Dear driver, if you are unable to serve the passenger after accepting an order due to personal or other reasons, please promptly apologize to the passenger and negotiate to cancel the order so the passenger can request another ride.',
        q3: 'Unable to Contact Passenger After Accepting Order',
        q3a: 'If you cannot reach the passenger after arriving at the pickup location: if you have cancelled less than once that day, you can cancel directly, and if the wait has timed out, you will receive timeout compensation. If you have cancelled more than once that day, please contact customer service to cancel — similarly, if the wait has timed out, you will also receive timeout compensation.',
        q4: 'How to Modify Order Price',
        q4a: 'If the order amount is abnormal and needs to be modified, please tap [Transfer to Agent] to report to customer service. Thank you for your understanding.',
      },
      withdraw: {
        title: 'Withdrawal Related',
        q1: 'How to Withdraw',
        q1a: 'Tap the top-left corner of the driver app [Me] • [Wallet] • [Withdraw] to withdraw funds. Withdrawals can only be made to your own Alipay account. See [Withdrawal Rules] below for details. No service fee is charged for withdrawals.',
        q2: 'Withdrawal Arrival Time',
        q2a: 'Funds will arrive within 2 hours after a successful withdrawal. If not received after that, please check your Alipay transaction details and whether the funds were returned to your driver account.',
      },
      reward: {
        title: 'Rewards Related',
        q1: 'Reward Not Received',
        q1Sub: 'Reasons for not receiving rewards:',
        q1a1: '1. Completed orders do not meet reward rules: Please check the reward page for required number of orders, completion rate, order time and location, etc. Only orders that meet the reward criteria will qualify.',
        q1a2: '2. Reward distribution time: Rewards are either distributed in real-time or after the campaign ends. Please refer to the distribution time in the reward rules to check your reward status.',
        q1a3: '3. Delayed reward distribution: When the number of reward recipients exceeds the limit or for other reasons, the platform will notify you in time. Please be patient and wait.',
        q2: 'Incorrect Reward Amount Received',
        q2a: 'If the reward amount received is incorrect, please first verify whether you met the reward requirements. You can calculate your reward amount based on your order history. If your reward meets the requirements but has not been distributed yet, we will reissue it within 7 days. Please monitor your account transactions.',
      },
      driverService: {
        title: 'Driver Service',
        q1: 'What Services Do Drivers Provide',
        q1a: 'Dear driver, good service earns passengers\' recognition and positive reviews. Arriving on time, keeping the car clean, and adjusting air conditioning based on passenger needs will provide a comfortable trip.',
      },
      extraFee: {
        title: 'Additional Fees',
        q1: 'How Are Highway / Bridge Tolls Handled',
        q1a: 'Dear driver, highway and bridge tolls are fees incurred when passing through highways and overpasses while serving passengers. When an order incurs such fees, the passenger should pay the driver offline after mutual confirmation.',
        q1Tip: 'Reminder: For round trips, you may only collect round-trip fees after communicating with the passenger.',
      },
      pricingRule: {
        workday: 'Workday Pricing Rules',
        restday: 'Rest Day Pricing Rules',
      },
    },
    table: {
      timePeriod: 'Time Period',
      startingPrice: 'Starting Price',
      mileagePrice: 'Mileage Unit Price',
      durationPrice: 'Duration Unit Price',
      longDistance20: 'Long Distance 20km Unit Price',
      longDistance30: 'Long Distance 30km Unit Price',
    },
  },
};

export function getHelpLang() {
  const search = window.location.search.replace(/\/$/, '');
  const params = new URLSearchParams(search);
  const lang = params.get('lang');
  if (lang === 'en-US' || lang === 'zh-TW') {
    return lang;
  }
  return 'zh-CN';
}

export function getHelpContent(lang) {
  return content[lang] || content['zh-CN'];
}

export default content;
